/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Radio } from '@mantine/core'

function WithBirthDateFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Radio
        checked={value == null}
        id="with_birthdate_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="withBirthDate"
        onChange={handleChangeEvent(onChange)}
        value=""
      />
      <Radio
        checked={value === 'true'}
        id="with_birthdate_filter"
        label={intl.formatMessage({
          id: 'with_birthdate',
          defaultMessage: 'Avec date de naissance'
        })}
        name="withBirthDate"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Radio
        checked={value === 'false'}
        id="without_birthdate_filter"
        label={intl.formatMessage({
          id: 'without_birthdate',
          defaultMessage: 'Sans date de naissance'
        })}
        name="withBirthDate"
        onChange={handleChangeEvent(onChange)}
        value="false"
      />
    </Filter>
  )
}

export default WithBirthDateFilter
